export default __webpack_public_path__ + "static/media/logo_tryunfo.a75bcf51.svg";